import * as browser from "detect-browser";

export function isIOSDevice() {
  try {
    if (typeof window === "undefined") return false;

    const browserInfo = browser?.detect();
    const userAgent = navigator?.userAgent;

    const isUserAgentIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (userAgent.includes("Macintosh") && "ontouchend" in document);

    const knownIOSBrowsers = ["crios", "fxios", "safari", "ios", "ios-webview"];

    return (
      isUserAgentIOS ||
      browserInfo?.os === "iOS" ||
      (browserInfo?.name && knownIOSBrowsers.includes(browserInfo?.name))
    );
  } catch (error) {
    console.log("Error detecting iOS device:", error);

    return false;
  }
}
